export default __webpack_public_path__ + "4dc3e1b117e4585f03e6209e553d4b23.png";